import { fetch } from 'http-common';

type ReactivationData = {
    customerId: string,
    active: boolean
}

class ReactivationDataService {
  private http = fetch();

  private ep = '/v1/customerReactivation/';

  public async checkReactivation(id: string) {
    return this.http.get<boolean>(`${this.ep}${id}`);
  }

  public async reactivate(id: string | null) {
    return this.http.post<ReactivationData>(`${this.ep}${id}`);
  }
}

const reactivationDataService = new ReactivationDataService();

export { reactivationDataService };
